module.exports = __webpack_public_path__ + "static/Karolína_Osickova_Mit_rád -8182e6ea03a88dd982d7cb97c8fa419b.mp3";